import { Button, Card, Group, Image, MantineTheme, Stack, Text, Title } from "@mantine/core";
import { getGoogleMapsStreetViewImage, latLng, RecordGroupManager, useEntityUI, ValuesRecord } from "@mcurros2/microm";
import { StandardViewColumnsOverrides } from "./StandardViewColumnsOverrides";

export function StandardViewInfoWindowRenderer(
    record: ValuesRecord,
    position: latLng,
    groupManager: RecordGroupManager,
    infoWindow: google.maps.InfoWindow,
    UIAPI: ReturnType<typeof useEntityUI>,
    theme: MantineTheme
)  {

    const columnsRender = StandardViewColumnsOverrides(theme);

    const group = groupManager.getGroupByLocation(position);

    if (group) {
        return (
            <Card withBorder>
                <Stack spacing="xs" mb="xs">
                    <Image width={350} height={120} src={getGoogleMapsStreetViewImage(position, 350, 200, 150)} mx="auto" />
                    {group.records.map(
                        ({ recordValue: rec }, index) => <Group key={`grp_${rec[0]}`}>
                            <Title order={5}>{`ID: ${rec[0]} ${rec[2]}${rec[2] && rec[1] ? ' - ' : ''}${rec[1]}`}</Title>
                            <Button size="xs" onClick={async () => {
                                await UIAPI.handleEditClick({ 'c_tienda_id': rec[0] });
                            }} >Editar</Button>
                        </Group>
                    )
                    }
                    <Group>
                        <Button size="xs" variant="light" onClick={() => {
                            infoWindow.close();
                        }}>Cerrar</Button>
                    </Group>
                </Stack>
            </Card>
        )
    }
    else {
        return (
            <Card withBorder>
                <Stack spacing="xs" mb="xs">
                    <Image width={350} height={120} src={getGoogleMapsStreetViewImage(position, 350, 200, 150)} mx="auto" />
                    <Title order={4}>{`${record[2]}${record[2] && record[1] ? ' - ' : ''}${record[1]}`}</Title>
                    <Group spacing="0.5rem">
                        <Text weight={500} size="sm">Personal: </Text>
                        {columnsRender[5]!.render!(record[5])}
                    </Group>
                    <Group spacing="0.5rem">
                        <Text weight={500} size="sm">Cantidad de Clientes: </Text>
                        {columnsRender[6]!.render!(record[6])}
                    </Group>
                    <Group spacing="0.5rem">
                        <Text weight={500} size="sm">Cantidad de Productos: </Text>
                        {columnsRender[7]!.render!(record[7])}
                    </Group>
                    <Group spacing="0.5rem">
                        <Text weight={500} size="sm">Estado: </Text>
                        {columnsRender[8]!.render!(record[8])}
                    </Group>
                    <Group position="right">
                        <Button size="xs" variant="light" onClick={() => {
                            infoWindow.close();
                        }}>Cerrar</Button>
                        <Button size="xs" onClick={async () => {
                            await UIAPI.handleEditClick({ 'c_tienda_id': record[0] });
                        }} >Editar</Button>
                    </Group>
                </Stack>
            </Card>
        )
    }
}